import React from "react";

const StatsKpiCard = ({ label, value, unit, variant = "primary", sub }) => (
  <div className={`stats-kpi-card stats-kpi-${variant}`}>
    <div className="stats-kpi-label">{label}</div>
    <div className="stats-kpi-value">
      {value}
      {unit && <span className="stats-kpi-unit">{unit}</span>}
    </div>
    {sub && <div className="stats-kpi-sub">{sub}</div>}
  </div>
);

export default StatsKpiCard;
